export const tradingContest = {
  cyjyds: "Participer au concours de trading",
  jsjxmh: "Débloquez des coffres surprises et gagnez des super prix !",
  hdsj: "Période de l'activité",
  mrjxsj: "Chaque jour de 00:00 à 23:59 UTC+8.",
  ckxxgz: "Voir les règles détaillées",
  wdjj: "Mes gains",
  jlkj: "Prochain tirage",
  cjjc: "Super cagnotte",
  jjmrzj: "La cagnotte augmente chaque jour",
  kqxjd: "Nouvelle phase, plus de récompenses",
  dyjd: "Première phase",
  dejd: "Deuxième phase",
  dsjd: "Troisième phase",
  dsijd: "Quatrième phase",
  jrmhjj: "Cagnotte des coffres du jour",
  syjj: "Cagnotte restante",
  yblqje: "Montant déjà réclamé",
  tjmh: "Coffre spécial",
  yjmh: "Coffre niveau 1",
  ejmh: "Coffre niveau 2",
  sjmh: "Coffre niveau 3",
  jj: "Gain :",
  gs: "unité(s)",
  djdkrymh: "Cliquez pour ouvrir un coffre surprise",
  kydk: "Vous pouvez ouvrir aujourd'hui",
  jxmh: "coffre(s) surprise(s)",
  dkmhxyxx: "Ouvrir un coffre nécessite {amount} étoiles.",
  xzyyxx: "Vous avez actuellement {amount} étoile(s)",
  xxqlsj: "Date de réinitialisation des étoiles : {date} (Veuillez réclamer vos coffres avant la réinitialisation)",
  wdxx: "Mes étoiles",
  xxhq: "Obtenir des étoiles",
  hqxxtj: "Moyens d'obtenir des étoiles",
  yxhysxf: "Contrats perpétuels : 1 étoile pour {amount}U de frais",
  qqhysxf: "Contrats d'options : 1 étoile pour {amount}U de volume",
  youxihysxf: "GameFi : 1 étoile pour {amount}U de volume",
  gxhd: "Félicitations ! Vous avez reçu",
  jlydrzh: "Cette récompense a été créditée sur votre {account}",
  qzjzhck: "Aller voir sur le compte de jeu",
  bwcjjc: "Super cagnotte BiKing",
  qmxjyds: "Concours de trading All-Star",
  gbgbyb: "Osez-vous tenter le coup ?",
  bwcjjcdnn: "Super cagnotte BiKing, {amount}% de la cagnotte quotidienne en coffres à gagner !",
  cjjcqmxjys: "La super cagnotte du concours All-Star BiKing, {amount}% de la cagnotte quotidienne + coffres surprises,",
  syyxbd: "Ouvrez et gagnez gros !",
  zgtk: "Envie d'atteindre le sommet ? Affrontez-vous !",
  zhyz: "{amount}% de la cagnotte quotidienne s'accumule pour la dernière bataille,",
  dfdj: "Qui remportera le prix ultime de BiKing ?",
  gsjj: "Les meilleurs traders s'affrontent sur la super cagnotte BiKing,",
  qmxpk: "Le duel All-Star révèle les vrais champions !",
  jymh: "Tradez, ouvrez des coffres, montez dans le classement, dominez l'arène BiKing !",
  zzbzy: "Contrats perpétuels, options, GameFi, trading spot : 4 semaines de gameplay évolutif, chaque semaine est différente !",
  jlfh: "Super cagnotte BiKing, récompenses généreuses à la clé. Gloire et gains vous attendent !",
  mh: "Coffre",
  cb: "Classement",
  jy: "Trading",
  syxxs: "Étoiles restantes",
  xxbhs: "Variation d'étoiles",
  sjlx: "Type d'événement",
  jycp: "Produit tradé",
  jye: "Volume tradé",
  myxgjl: "Vous n'avez pas encore reçu de récompense",
  jyhd: "Gagné via le trading",
  ql: "Réinitialiser",
  kqmh: "Ouvrir le coffre",
  yx: "Jeu GameFi",
  bchdyjs: "Cette activité est terminée",
  gffjj: "Montant total des gains distribués",
  kqmhsl: "Nombre de coffres ouverts",
  cjjcjj: "Gains de la super cagnotte",
  cjjchjmd: "Liste des gagnants de la super cagnotte",
  jjdyyh: "Les gains ont été crédités sur le compte utilisateur",
  hdjj: "Gains obtenus",
  wff: "Non distribué",
  mhhjjl: "Historique des gains par coffre",
  cjdjhjjl: "Historique des super gains",
  jjse: "Montant du gain",
  xhxxs: "Étoiles consommées",
  bwqmxgz: "Règles du concours de trading All-Star BiKing",
  hdnr: "Contenu de l'activité",
  hdnrgz: "Le concours All-Star BiKing couvre quatre domaines : contrats perpétuels, contrats d'options, jeux GameFi et trading spot. L'activité est divisée en quatre semaines, avec déblocage progressif de nouveaux produits chaque semaine. Gagnez des 'étoiles' grâce à vos trades et remportez des récompenses généreuses. {total}% de la cagnotte quotidienne est alloué aux coffres surprises : ouvrez et gagnez instantanément ! Les {amount}% restants s'accumulent jusqu'à la fin du concours et sont distribués selon le classement des transactions !",
  hdjd: "Phases de l'activité",
  jbjs: "Déblocage progressif, quatre cycles de compétition",
  dyzq: "Premier cycle",
  kqyxhy: "Début du trading de contrats perpétuels. Plus vous tradez, plus vous gagnez d'étoiles et plus la cagnotte est élevée !",
  dezq: "Deuxième cycle",
  jmqqjy: "Ajout du trading de contrats d'options. Les bénéfices et pertes s'accumulent dans la cagnotte. Augmentez encore votre nombre d'étoiles.",
  dszq: "Troisième cycle",
  cjgejc: "Ajout des jeux GameFi. Obtenez des étoiles via des expériences de trading variées et visez la cagnotte maximale.",
  dsizq: "Quatrième cycle",
  gfzzdj: "La cagnotte des coffres des trois premières semaines reste ouverte. Un classement distinct pour le trading spot permet de partager les prix finaux !",
  jzszjs: "Calcul des montants de la cagnotte",
  jxmhgz1: "{amount}% de la cagnotte quotidienne est alloué aux coffres. 100 coffres sont disponibles chaque jour. Quatre niveaux de prix pour une expérience pleine de surprises. Les récompenses non réclamées s'accumulent automatiquement pour le lendemain. Coffres spéciaux et coffres niveau 1 sont renouvelés quotidiennement. Taux de gain élevé !",
  mhfpmx: "Total de {total} coffres par jour, représentant {amount}% de la cagnotte quotidienne. Répartition :",
  tjmhzb: "{total} coffre(s) spécial(aux), représentant {amount}% de la cagnotte",
  yjmhzb: "{total} coffre(s) niveau 1, représentant {amount}% de la cagnotte",
  ejmhzb: "{total} coffre(s) niveau 2, représentant {amount}% de la cagnotte",
  sjmhzb: "{total} coffre(s) niveau 3, représentant {amount}% de la cagnotte",
  kmhxxyq: "Nombre d'étoiles requis pour ouvrir un coffre : Montant de la cagnotte quotidienne des coffres / {text}",
  tips: "Attention : Tous les coffres sont réinitialisés chaque jour à 0h00. Leur contenu est recalculé en fonction de la cagnotte générée la veille par les transactions + le montant non réclamé des coffres du jour précédent, puis réparti selon les niveaux et proportions ci-dessus.",
  mrjyyk: "La cagnotte totale est basée sur les bénéfices/pertes quotidiens des transactions sur les contrats perpétuels, les options et GameFi.",
  mgyld: "{amount}% de chaque transaction gagnante = montant du gain * {amount}%",
  mrjcljdjs: "{amount}% de la cagnotte quotidienne est accumulé jusqu'à la fin de l'activité et distribué aux trois premiers du classement des quatre produits. Répartition de la cagnotte accumulée : contrats perpétuels 40%, options 30%, GameFi 20%, spot 10%.",
  yhhyyld: "Exemple : Si un utilisateur gagne 1000U sur un contrat, alors 1000 * {amount}% = {total}U entre dans la cagnotte du jour.",
  mgksd: "{amount}% de chaque transaction perdante = montant réel de la perte * {amount}%",
  yhhyks: "Exemple : Si un utilisateur perd réellement 1000U sur un contrat, alors 1000 * {amount}% = {total}U entre dans la cagnotte du jour.",
  qqhyyld: "{amount}% de chaque transaction gagnante = mise * cote * {amount}%",
  qqyhddtz: "Exemple : Un utilisateur mise 100U sur une option avec un cycle de 10 secondes et gagne : 100 * 65% * {amount}% = {total}U entrent dans la cagnotte du jour.",
  qqhyksd: "{amount}% de chaque transaction perdante = montant de la perte * {amount}%",
  yhksjrjc: "Exemple : Un utilisateur perd 100U sur une option : 100 * {amount}% = {total}U entrent dans la cagnotte du jour.",
  yxyld: "{amount}% de chaque transaction gagnante = mise * cote * {amount}%",
  yxddtz: "Exemple : Un utilisateur mise 100U sur un jeu GameFi avec une cote de 2 et gagne : 100 * 200% * {amount}% = {total}U entrent dans la cagnotte du jour.",
  yxmgksd: "{amount}% de chaque transaction perdante = montant de la perte * {amount}%",
  yhqqksd: "Exemple : Un utilisateur perd 100U sur une option : 100 * {amount}% = {total}U entrent dans la cagnotte du jour.",
  daiding: "À déterminer",
  yytz: "Ajustements de l'activité",
  kaiqi: "Démarrer",
  xhjyjrpm: "Ajout du trading spot au classement",
  drjy: "Trading du jour, récompenses le lendemain",
}


// WEBPACK FOOTER //
// ./src/i18n/lang/tradingContest/fr.js